import { render, staticRenderFns } from "./V2MultiSelect.vue?vue&type=template&id=3545f2c7&scoped=true&"
import script from "./V2MultiSelect.vue?vue&type=script&lang=js&"
export * from "./V2MultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./V2MultiSelect.vue?vue&type=style&index=0&id=3545f2c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545f2c7",
  null
  
)

export default component.exports